import initializeComponent from 'Shared/react-initialize';
import { PatrolDashboard } from './PatrolDashboard';

initializeComponent('Patrol', PatrolDashboard);
